
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../Component/Loader';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import BannerImageAd from '../../Component/BannerImageAd';
import BlogCard from '../../Component/BlogCard';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import HeadingWithUnderline from '../../Component/HeadingWithUnderline';
import NoData from '../../Component/NoData/NoData';
import SearchInput from '../../Component/SearchInput';
import Tabs from '../../Component/Tabs';
import { imageUrl, recordsLimit } from '../../config/apiUrl';
import { useLazyGetApiQuery } from '../../store/apiSlice/apiSlice';
import classes from './Blogs.module.css';

const Blogs = () => {
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { allBanners } = useSelector((state) => state.commonReducer);

  const horizontalBanner = allBanners?.find(
    (item) => item?.page === 'blogs' && item?.bannerType == 'horizontal'
  );
  const navigate = useNavigate();
  const tabsArray = [
    { id: 1, text: t('blogs.tab1'), value: 'latest' },
    { id: 2, text: t('blogs.tab2'), value: 'popular' }
  ];
  const [selectedTab, setSelectedTab] = useState(tabsArray[0]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const [getApiFunc, { isLoading, data: response, isFetching }] = useLazyGetApiQuery();

  const getData = async (pg = page, type = selectedTab?.value) => {
    await getApiFunc({
      url: `blog?page=${pg}&limit=${recordsLimit}&search=${search}&lan=${selectedLanguage}&type=${type}`,
      tag: `Blogs`
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const renderBlogs = () => {
    if (isLoading || isFetching) {
      return [<Loader key="loader" />];
    }
    
    if (response?.data?.length === 0) {
      return [<NoData key="no-data" text={t('blogs.noData')} />];
    }
    
    return response?.data?.map((item, key) => (
      <Col
        xl={4}
        lg={4}
        md={4}
        sm={6}
        key={`${item?._id}-${key}`}
        style={{
          marginBottom: '25px'
        }}>
        <BlogCard data={item} onClick={() => navigate(`/blog/${item?.slug}`)} />
      </Col>
    )) || [];
  };

  return (
    <div className={classes.page}>
      <Header containerClass="" />
      <Container className={classes?.main}>
        <Row className={[classes.pt30, classes.row].join(' ')}>
          {/* Featured Prop */}
          <Col md={8}>
            <HeadingWithUnderline underlineColor={'#00A997'} className={classes.sectionHeading}>
              <h2>{t('blogs.title')}</h2>
            </HeadingWithUnderline>
          </Col>
          <Col md={4}>
            <SearchInput
              containerStyleIcon={{
                borderRadius: '0 5px 5px 0',
                background: '#00A997'
              }}
              className={classes.searchInput}
              placeholder={t('blogs.search')}
              state={search}
              setter={setSearch}
              onClick={() => {
                setPage(1);
                getData(1);
              }}
            />
          </Col>
          <Col md={12}>
            <div className={classes?.tabsWrapper}>
              <Tabs
                tabsData={tabsArray}
                value={selectedTab}
                setValue={(e) => {
                  setSelectedTab(e);
                  setPage(1);
                  getData(1, e?.value);
                }}
                className={classes?.tabsContainer}
                scrollOffset={150}
              />
            </div>
          </Col>
          {renderBlogs()}
          {response?.data?.length > 0 && (
            <Col md={12} className={classes.paginationDiv}>
              <PaginationComponent
                currentPage={page}
                totalPages={Math.ceil(response?.totalRecords / recordsLimit)}
                setCurrentPage={(e) => {
                  setPage(e);
                  getData(e);
                }}
              />
            </Col>
          )}
          <Col md={12}>
            {horizontalBanner?.image && (
              <BannerImageAd
                link={horizontalBanner?.link}
                image={imageUrl(horizontalBanner?.image)}
                className={`bannerHorizontal ${classes.banner}`}
              />
            )}
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Blogs;
